import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [
    { id: 1, name: 'Анна Смирнова', status: 'online', isFriend: false },
    { id: 2, name: 'Иван Петров', status: 'offline', isFriend: true },
    { id: 3, name: 'Мария Сидорова', status: 'online', isFriend: false },
    { id: 4, name: 'Дмитрий Иванов', status: 'offline', isFriend: false },
  ],
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    toggleFriend: (state, action) => {
      const user = state.users.find(u => u.id === action.payload);
      if (user) {
        user.isFriend = !user.isFriend; // Переключаем статус друга
      }
    },
  },
});

export const { toggleFriend } = usersSlice.actions;
export default usersSlice.reducer;